<template>
  <template v-if="campaignData?.campaigns">
    <template v-if="campaignData.count">
      <TheCard>
        <div
          class="tw-divide tw-divide-y-2 tw-divide-x-0 tw-divide-gray-100 tw-divide-solid"
        >
          <RedemptionHistoryListItem
            v-for="campaign in this.campaignData.campaigns"
            :key="campaign._id"
            :campaign="campaign"
          >
          </RedemptionHistoryListItem>
        </div>
      </TheCard>
    </template>
    <template v-else>
      <TheCard>
        <EmptyState emptyState="gifts"></EmptyState>
      </TheCard>
    </template>
  </template>
</template>

<script>
import TheCard from "../../components-v2/ui/layout/TheCard";
import RedemptionHistoryListItem from "./RedemptionHistoryListItem.vue";
import EmptyState from "../ui/feedback/EmptyState.vue";

export default {
  name: "RedemptionHistoryList",
  components: {
    RedemptionHistoryListItem,
    TheCard,
    EmptyState,
  },
  props: {
    campaignData: {
      type: Object,
    },
  },
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
